import {domLoader} from "@/loader.js";
import {debug} from "@/debug.js";

window.iconsLoaded = false;

addClickHandler(".vmpi", (event) => {
  document.querySelectorAll(".vmpi").forEach(el => {
    el.remove()
  })
  let tag = document.getElementById("tab-description");
  tag.classList.add("show");
})


domLoader(() => {
  if (window.iconsLoaded) {
    return;
  }
  window.iconsLoaded = true;

  document.addEventListener("keyup", (event) => {
    if (event.target.classList.contains("number-format")) {

      let value = event.target.value;
      value = value.replace(/[^0-9]/g, "");
      if (value) {
        let numberValue = parseInt(value);

        let formatted = numberValue.toLocaleString('en-US');
        event.target.value = formatted;

      } else {
        event.target.value = ""; // اگر چیزی وارد نشده یا همه چیز حذف شده
      }
    }
  });

  debug.log("layouts loaded")



})
